import { toast } from 'sonner';

/* Einheitliche Rückmeldung für fehlgeschlagene Speichern-/Senden-Anfragen im Portal:
   Server-Fehler (5xx) und Netzwerkabbrüche bei POST/PUT/PATCH/DELETE auf /api werden zentral gemeldet –
   auch dort, wo ein Formular den Fehlerfall selbst nicht behandelt. Eingaben bleiben erhalten. */
const MUTATING = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);
let installiert = false;

const errorToasts = () => document.querySelectorAll('[data-sonner-toast][data-type="error"]').length;
// Nur melden, wenn die Seite den Fehler nicht selbst (per Toast) behandelt hat – sonst doppelte Meldungen
const meldeWennUnbehandelt = (vorher, text, id) => {
  setTimeout(() => { if (errorToasts() <= vorher) toast.error(text, { id }); }, 400);
};

export const installFetchFeedback = () => {
  if (installiert || typeof window === 'undefined' || !window.fetch) return;
  installiert = true;
  const original = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const method = (init.method || (input && input.method) || 'GET').toUpperCase();
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const relevant = MUTATING.has(method) && url.includes('/api/') && window.location.pathname.startsWith('/portal');
    const vorher = relevant ? errorToasts() : 0;
    try {
      const res = await original(input, init);
      if (relevant && res.status >= 500) {
        meldeWennUnbehandelt(vorher, `Speichern fehlgeschlagen (Server-Fehler ${res.status}). Ihre Eingaben bleiben erhalten – bitte erneut versuchen.`, `srv-${url.split('?')[0]}`);
      }
      return res;
    } catch (e) {
      if (relevant) {
        meldeWennUnbehandelt(vorher, 'Keine Verbindung zum Server. Ihre Eingaben bleiben erhalten – bitte erneut versuchen.', 'netz');
      }
      throw e;
    }
  };
};
